module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.953a8c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatsapp-icon.png
// module id = 304
// module chunks = 0